import { get, isEmpty } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player/youtube";
import { api } from "../../../../views/thinking-layout-editor/utils/InstanceAPI";
import { NEW_EDGE_REG } from "@views/thinking-layout-editor/constants";
import LoadMore from "../components/LoadMore";
import { useReactFlow } from "reactflow";
import styles from "./Video.module.css";
import utilIndex from "../../../../views/thinking-layout-editor/utils";

const VideoNode = props => {
  const playerWrapperRef = useRef(null);

  const [{ context, continuation, empty, key, items = [], query } = {}, setVideoInfo] = useState();
  const [videoList, setVideoList] = useState([]);
  const [activeVideoUrl, setActiveVideoUrl] = useState();
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const { getNodes, getEdges } = useReactFlow();

  const YOUTOBEICON = "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/230704/youtobe_icon.png";

  const { content = {}, resizeEventParams = {}, dragging, noWheelClassName, initialReportSize } = props;

  const { height = initialReportSize.height, width = initialReportSize.width } = resizeEventParams;

  const firstPageVideoInfo = useMemo(() => {
    let result = content;
    if (typeof content === "string") {
      try {
        result = JSON.parse(content);
      } catch (error) {
        console.log(error);
      }
    }
    return result;
  }, [content]);

  const handleClickSelectVideo = url => {
    setActiveVideoUrl(url);
  };

  const handleKeyword = () => {
    const nodeId = props.nodeId || props.id;
    const nodesArr = getNodes();
    const edgesArr = getEdges();
    let hasOriginNode = edgesArr.find(x => x.target === nodeId);

    // v3版本 还需要顺着往前找到sourceNode
    if (NEW_EDGE_REG.test(hasOriginNode.source)) {
      hasOriginNode = edgesArr.find(x => x.target === hasOriginNode.source);
    }

    if (isEmpty(hasOriginNode)) {
      return;
    }

    const originNode = hasOriginNode.source;
    const originNodeContent = nodesArr.find(x => x.id === originNode);

    if (isEmpty(originNodeContent)) return;

    const keyword = utilIndex.getTextFromTextAreaValueByType(originNodeContent.data);
    // 只处理返回为字符串的问题，其他类型为空
    if (typeof keyword === "string") {
      setKeyword(keyword);
    }
  };

  const handleClickLoadMore = async () => {
    try {
      setLoading(true);

      const result = await api
        .post(`/be/svc-adapter/youtube/v2/search`, {
          context,
          continuation,
          key,
        })
        .then(response => response.json());

      setVideoInfo(result.data);
      setVideoList(list => [...list, ...result.data.items]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetVideoNodeState = useCallback(() => {
    setKeyword(firstPageVideoInfo.query);
    setVideoInfo(firstPageVideoInfo);
    setVideoList(firstPageVideoInfo.items || []);
    setActiveVideoUrl(get(firstPageVideoInfo.items, [0, "url"]));
  }, [firstPageVideoInfo]);

  useEffect(() => {
    resetVideoNodeState();
  }, [firstPageVideoInfo]);

  useEffect(() => {
    if (playerWrapperRef.current) {
      const iframeNode = playerWrapperRef.current.querySelector("iframe");
      if (iframeNode) {
        iframeNode.style["pointer-events"] = dragging === true ? "none" : "auto";
      }
    }
  }, [dragging]);

  const { videoPlayerHeight, videoListHeight } = useMemo(
    () => ({
      videoPlayerHeight: (height - 85) * (6 / 13),
      videoListHeight: (height - 85) * (7 / 13),
    }),
    [height]
  );

  return (
    <div className={`${styles.scrollContent} ${props.isTargetNode ? styles["target"] : ""}`} ref={playerWrapperRef}>
      <div className={styles.keywordContent}>
        <div>
          <img src={YOUTOBEICON} alt="" />
        </div>
        <p>{keyword}</p>
      </div>
      <ReactPlayer
        url={activeVideoUrl}
        width={"100%"}
        height={videoPlayerHeight}
        style={{ width: "100%", height: "100%", borderRadius: "10px", overflow: "hidden", marginBottom: "15px" }}
        controls={true}
      />
      <div className={`${styles.scrollList} ${noWheelClassName}`} style={{ height: videoListHeight }}>
        {videoList.map(({ length, thumbnailUrl, title, url }) => {
          return (
            <div
              className={`${styles["video-item"]} ${activeVideoUrl === url ? styles["active"] : ""}`}
              onClick={() => handleClickSelectVideo(url)}
              style={{ maxWidth: 385 + width - initialReportSize.width }}
              key={url}
            >
              <div className={styles["video-image"]}>
                <img src={thumbnailUrl} alt="" />
              </div>
              <div className={styles["video-item-content"]}>
                <div>{title}</div>
                <span>{length}</span>
              </div>
            </div>
          );
        })}
        <LoadMore noMore={empty || items.length === 0} loading={loading} onClick={handleClickLoadMore} />
      </div>
    </div>
  );
};

export default VideoNode;
